import React from 'react';
import '../../css/Introduction.css';
import SponsoredSection from './SponsoredSection';

const Introduction = () => {
    return (
        <>
            <SponsoredSection />
            <div className="introduction-banner">
                <div className="container" id="introduction-container">
                    <p className="introduction-title">
                        Explore our comprehensive maritime education library.
                    </p>
                    <p className="introduction-text">
                        Master maritime communication from basic to advanced with D-Smart’s clear, easy tools.
                    </p>
                </div>
            </div>
        </>
    );
};

export default Introduction;